import checkedInIcon from '../static/img/DailyTasks/iconPastTask.png';
import currentCheckInIcon from '../static/img/DailyTasks/iconDailyTaskFrame.svg';
import notCheckedInIcon from '../static/img/DailyTasks/iconLockedTask.png';

import styles from '../static/styles/DailyTasks.module.css';

const DailyTaskItem = ({ day, activeDay, taskImage }) => {
  let status;
  if (day < activeDay) {
    status = 'claimed';
  } else if (day === activeDay) {
    status = 'current';
  } else {
    status = 'locked';
  }

  let backgroundIcon;
  if (status === 'claimed') {
    backgroundIcon = checkedInIcon;
  } else if (status === 'current') {
    backgroundIcon = currentCheckInIcon;
  } else {
    backgroundIcon = notCheckedInIcon;
  }

  return (
      <div
        className={styles.checkinContent}
        style={{ backgroundImage: `url(${backgroundIcon})` }}
      >
        {taskImage && <img src={taskImage} alt={'Task'} className={styles.taskImage} />}
      </div>
  );
};

export default DailyTaskItem;